import { logWarn } from '../state/log-store.js';
import { renderTemplateSlot } from '../templates/render-template.js';
import { resolvePlaybackUrl, revokePlaybackBlobUrls } from '../storage/media-cache.js';

export async function renderSlot(rootEl, slot, { onEnded, isStale } = {}) {
  revokePlaybackBlobUrls();
  rootEl.innerHTML = '';
  if (!slot) return;

  if (slot.kind === 'media' && slot.mediaUrl) {
    const src = await resolvePlaybackUrl(slot.mediaUrl);
    if (isStale?.()) return;
    if (slot.mediaType === 'video') {
      const video = document.createElement('video');
      video.src = src;
      video.autoplay = true;
      video.muted = true;
      video.playsInline = true;
      video.loop = false;
      video.classList.add('fade-in');
      video.addEventListener('ended', () => onEnded?.());
      let errorHandled = false;
      video.addEventListener('error', () => {
        if (errorHandled) return;
        errorHandled = true;
        logWarn('Video load error', {
          url: slot.mediaUrl,
          src,
          offline: !navigator.onLine,
        });
        setTimeout(() => onEnded?.(), 5000);
      });
      if (isStale?.()) return;
      rootEl.appendChild(video);
      video.play().catch(() => {
        logWarn('Video autoplay blocked', { url: slot.mediaUrl });
      });
    } else {
      const img = document.createElement('img');
      img.src = src;
      img.alt = '';
      img.classList.add('fade-in');
      img.addEventListener('error', () => {
        logWarn('Image load error', { url: slot.mediaUrl, offline: !navigator.onLine });
      });
      if (isStale?.()) return;
      rootEl.appendChild(img);
    }
  } else if (slot.kind === 'template' && slot.templateId) {
    if (isStale?.()) return;
    const el = document.createElement('div');
    el.className = 'fade-in tpl-root';
    rootEl.appendChild(el);
    // Error boundary intorno al rendering del template (redesign-v2/03-player):
    // un templateConfig malformato non deve crashare la rotation. Loggiamo
    // e mostriamo un placeholder, poi advance al prossimo slot dopo 5s.
    try {
      renderTemplateSlot(el, slot);
    } catch (err) {
      const message =
        err && typeof err === 'object' && 'message' in err ? err.message : String(err);
      logWarn('Template render error', {
        templateId: slot.templateId,
        slotId: slot.id,
        error: message,
      });
      el.innerHTML = '';
      const fallback = document.createElement('div');
      fallback.className = 'slot-template-error';
      fallback.textContent = `Modello "${slot.templateId}" non disponibile`;
      el.appendChild(fallback);
      setTimeout(() => onEnded?.(), 5000);
    }
  } else {
    const placeholder = document.createElement('div');
    placeholder.className = 'slot-unsupported';
    placeholder.textContent = `Tipo "${slot.kind ?? 'sconosciuto'}" non supportato dal player`;
    rootEl.appendChild(placeholder);
  }
}
